<script>
import appConfig from "@/app.config";
import Layout from "../../layouts/auth";
import { mapGetters, mapState } from "vuex";
import { authMethods } from "@/state/helpers";
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
import modal from '../../../components/modal-notificacion';

export default {
  data() {
    return {
      error: false,
      typeError: "",
      errorModal: false,
      busy: false,
      isChecked: false,
      objetoUser: {
        company: process.env.VUE_APP_COMPANY,
        email: "",
        pass: "",
        url: process.env.VUE_APP_API_URL,
        submitted: false,
        authError: null,
        tryingToLogin: false,
        isAuthError: false,
      },
    };
  },
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    modal
  },
  validations: {
    email: {
      required,
      email,
    },
    pass: {
      required,
    },
  },
  computed: {
    ...mapGetters("auth", ["contacto"]),
    ...mapState("authfack", ["status"]),
  },
  methods: {
    ...authMethods,
    //...mapActions('auth', ['logInMitta']),
    //...authFackMethods,
    async loginPortal() {
     this.busy = true;
      this.submitted = true;
      this.tryingToLogin = true;
      this.authError = null;
      this.logInMitta(this.objetoUser)
        .then(resp => {
          this.tryingToLogin = false;
          this.isAuthError = false;
          if (resp.status === 200) {
            axios.get(`${process.env.VUE_APP_API_MITTA_TOKEN_PROXY}/default/Mitta-Login`)
            .then(resp => {
              if (this.isChecked) {
                localStorage.setItem('recordarMITTA', this.objetoUser.email);
              }
              localStorage.setItem('token', resp.data);            
              this.$store.dispatch('rutEmpresa/getEmpresas', this.$store.getters["auth/contacto"].identificador)  
              this.$router.push({ name: "default" })
            })
            .catch(()=>{
              this.$router.push({ name: "logout" })
              this.errorModal = true;
              this.typeError = "Error al conectarse con MITTA"
              this.busy = false;
              this.error = true;
            })
          } 
          else {
            this.busy = false;            
            this.errorModal = true;
            this.typeError = "Usuario y/o contraseña incorrecto"
            this.error = true;
          }
        })
        .catch(error => {
          this.tryingToLogin = false;
          this.authError = error ? error : "";
          this.isAuthError = true;
          this.errorModal = true;
          this.typeError = "Error al conectarse con BA360"
          this.busy = false;
          this.error = true;          
        });      
    },
    limpiar() {
      this.$store.dispatch("auth/limpiar");
    },
  },
  mounted() {
    let usuario = localStorage.getItem('recordarMITTA');
    if (usuario){
      this.objetoUser.email = usuario;
      this.$refs.pass.focus()
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
          <div class="card-body px-lg-5 py-lg-5">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div>
                  <div class="header-back row">
                    <div class="col-7">
                      <div class="text-header p-4 justify-content-center">
                        <h5 class="text-header">¡Bienvenido!</h5>
                        <p>Regístrese para ingresar al portal.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div>
                  <router-link tag="a" to="/">
                    <div class="profile-user-wid mb-4">
                      <span class="logo-back avatar-title">
                        <img
                          src="@/assets/images/Logo_Mitta_Black.png"
                          alt
                          height="34"
                        />
                      </span>
                    </div>
                  </router-link>
                </div>
                
                <form role="form">
                  <b-form-group
                    id="input-group-1"
                    label="Correo"
                    label-for="input-1"
                  >
                    <b-form-input
                      class="input-group-alternative mb-3"
                      placeholder="nombre@dominio.com"
                      addon-left-icon="ni ni-email-83"
                      v-model="objetoUser.email"
                      v-on:keyup.enter="loginPortal"
                    />
                  </b-form-group>
                  <b-form-group
                    id="input-group-2"
                    label="Contraseña"
                    label-for="input-2"
                  >
                    <b-form-input
                      class="input-group-alternative"
                      placeholder="Su Clave Segura"
                      type="password"
                      addon-left-icon="ni ni-lock-circle-open"
                      v-model="objetoUser.pass"
                      v-on:keyup.enter="loginPortal"
                      ref="pass"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-checkbox
                    v-model="isChecked"
                  >
                    Recuerdame
                  </b-form-checkbox>
                  
                  <div class="mt-3">
                    <b-button
                      variant="danger"
                      class="btn-block"
                      @click="loginPortal"
                    >
                      <strong v-if="busy == false">Ingresar</strong>
                      <b-spinner small  v-else class="align-items-center justify-content-center"/>
                    </b-button>
                  </div>
                  <div class="text-right">
                    <router-link
                      class="my-2 mt-5 text-xs"
                      style="cursor: pointer"
                      to="/recuperarpass"
                    >
                      ¿Olvidaste tu contraseña?</router-link
                    >
                  </div>
                </form>
              </div>
            </div>
            <modal
              :mensaje = this.typeError
              :error = this.errorModal
              v-show="error"
              @close="error = false"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.vue-notification {
  margin-top: 15px;
}
.logo-back {
  background: #000000;
}
.header-back {
  background: #ff0000;
}
.text-header {
  color: #ffffff;
}
</style>
